<nav class="navbar bg-transparent position-relative z-1 flex-shrink-0 py-2 py-lg-3">
  <div class="container">
    <div class="d-flex align-items-center justify-content-between w-100 rounded-pill border border-dark bg-white shadow px-3 py-2">
      <router-link to="/" class="navbar-brand d-flex align-items-center gap-2 m-0" aria-label="AI Campus Data Intelligence home">
        <span class="aic-hero-nav-logo d-block" aria-hidden="true"></span>
        <span class="d-none d-sm-flex flex-column lh-1">
          <strong class="text-dark small">AI Campus</strong>
          <small class="aic-hero-nav-tagline text-secondary text-uppercase">Data Intelligence</small>
        </span>
      </router-link>

      <router-link to="/login" class="btn btn-danger btn-sm rounded-pill fw-semibold px-3 py-1">
        Sign in
      </router-link>
    </div>
  </div>
</nav>
